import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../locales/en/common.json';
import ptCommon from '../locales/pt/common.json';

// Basic i18n initialization. We rely on external LocaleContext to control language.
// Advantage: predictable language switching and persistence already implemented.

// Initialize once. Keep guard to prevent double re-init causing stale resource state.
if (!i18n.isInitialized) {
  const persisted = (typeof window !== 'undefined' && window.localStorage.getItem('locale')) || 'en-US';
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        'en-US': { common: enCommon },
        'pt-BR': { common: ptCommon }
      },
      lng: persisted,
      fallbackLng: 'en-US',
      ns: ['common'],
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      initImmediate: false
    });
  // Debug diagnostics (remove later)
  if (typeof window !== 'undefined') {
    console.log('[i18n] initialized language =', i18n.language);
    console.log('[i18n] resources keys =', Object.keys(i18n.store.data || {}));
    console.log('[i18n] has en-US common?', i18n.hasResourceBundle('en-US','common'));
    console.log('[i18n] has pt-BR common?', i18n.hasResourceBundle('pt-BR','common'));
  }
}

export default i18n;
